const t = (e) => {
  if (e.startsWith("--"))
    return e;
  let a;
  return /^[A-Z0-9_]+$/.test(e) ? a = e.toLowerCase().replace(/_/g, "-") : a = e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), `--market-${a}`;
};
export {
  t as default
};
